module.exports = __webpack_public_path__ + "img/CBowman64_ua.3d15d08b.webp";